/**
 * Don't change the order of this array, we are constructing the components of step 3
 * using the index of this array
 */

export default {
  reasonList: [
    {
      title: "Haven’t made enough sales to justify the cost",
      header: "Not enough Sales?"
    },
    {
      title: "Didn’t find the products I am looking for",
      header: "Not the right products?"
    },
    {
      title: "I won't be selling as many products",
      header: "Won’t be selling as many products?"
    },
    {
      title: "Didn’t find enough Premium products",
      header: "Not enough premium products?"
    },
    {
      title: "Didn’t get enough time to try the app",
      header: "Didn’t get enough time?"
    },
    {
      title: "This is temporary, I’ll come back when the time is right",
      header: "Downgrade Spocket"
    },
    {
      title: "I cannot afford it",
      header: "Cannot afford Spocket Pro?"
    },
    {
      title: "Other",
      header: "Downgrade Spocket"
    }
  ],
  lastThreeReasons: [
    {
      title: "This is temporary, I’ll come back when the time is right",
      header: "Downgrade Spocket"
    },
    {
      title: "I cannot afford it",
      header: "Cannot afford Spocket Pro?"
    },
    {
      title: "Other",
      header: "Downgrade Spocket"
    }
  ]
};



// WEBPACK FOOTER //
// ./src/components/_Shared/Modals/DowngradePlanModal/data.js